import React, { PureComponent } from "react";
//import PropTypes from 'prop-types';
import { DropTarget } from "react-dnd";
import { connect } from "../../utils";
import { List, ListProducts } from "../../../components/dealgroup";
import { RestApiProductList } from "../../../../restClient";
const target = {
  drop(props, monitor, component) {
    if (!monitor.didDrop()) {
      props.layoutState.insertOrMoveItem(
        props.id,
        props.children.length,
        monitor.getItem()
      );
    }
  },
};
class EditLayout extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      values: [],
      productsContent: [],
    };
  }

  componentWillMount() {
    const { id, layoutState } = this.props;

    const listID = JSON.parse(localStorage.getItem(`DealGroupViewID${id}`));
    const { list } = layoutState.getItemJS(id).props.values;
    let newValue = [];
    if (Array.isArray(list)) {
      newValue = list;
    }
    if (newValue.join() === listID) {
      const productlist = "DealGroupView" + id;
      const listProduct = JSON.parse(localStorage.getItem(productlist));
      this.setState({
        productsContent: listProduct,
        values: newValue,
      });
    } else {
      this.getProductList();
    }
  }

  getProductList = () => {
    const { id, layoutState } = this.props;
    const { listProduct } = layoutState.getItemJS(id).props.values;
    let newValue = [];
    if (Array.isArray(listProduct)) {
      newValue = listProduct;
    }

    //if (arraysEqual(newValue, this.state.values) === false) {}
    let params = newValue.join();
    const url = "/products?collections=" + params;
    RestApiProductList(url)
      .then((response) => {
        return response.json();
      })
      .then((items) => {
        // this is for check unmounting components
        //console.log(this.unmounting);
        if (this.unmounting) {
          return;
        }

        if (items && !items.messages) {
          let newItems = [];
          for (var i = 0; i < items.length; ++i) {
            for (var j = 0; j < items[i].products.length; ++j)
              newItems.push(items[i].products[j]);
          }
          this.setState({ productsContent: newItems, values: newValue });
        }
      })
      .catch((e) => {
        // console.error(e);
      });
  };
  componentWillUnmount() {
    this.unmounting = true;
  }
  render() {
    const {
      id,
      // children,
      // isOverCurrent,
      connectDropTarget,
      // type,
      layoutState,
      // readOnly,
    } = this.props;
    const { containerPadding, typeContent } = layoutState.getItemJS(
      id
    ).props.values;
    // console.log(layoutState.getItemJS(id).props.values);
    return connectDropTarget(
      <div
        style={{
          boxSizing: "border-box",
          position: "relative",
          height: "auto",
          display: "flex",
          width: "100%",
          padding: containerPadding,
          flex: 1,
        }}
      >
        {typeContent === "custom" && (
          <List values={layoutState.getItemJS(id).props.values} />
        )}
        {typeContent === "collection" && (
          <ListProducts
            values={layoutState.getItemJS(id).props.values}
            list={this.state.productsContent}
          />
        )}
      </div>
    );
  }
}
// const EditLayout = ({
//   id,
//   children,
//   isOverCurrent,
//   connectDropTarget,
//   type,
//   layoutState,
//   readOnly,
// }) => {
//   const { containerPadding, typeContent } = layoutState.getItemJS(
//     id
//   ).props.values;
//   console.log(layoutState.getItemJS(id).props.values);
//   return connectDropTarget(
//     <div
//       style={{
//         boxSizing: "border-box",
//         position: "relative",
//         height: "auto",
//         display: "flex",
//         width: "100%",
//         padding: containerPadding,
//         flex: 1,
//       }}
//     >
//       {typeContent === "custom" && (
//         <List values={layoutState.getItemJS(id).props.values} />
//       )}
//       {typeContent === "collection" && (
//         <ListProducts values={layoutState.getItemJS(id).props.values} />
//       )}
//     </div>
//   );
// };

const LayoutContainer = DropTarget(
  "DealGroupView",
  target,
  (conn, monitor) => ({
    connectDropTarget: conn.dropTarget(),
    isOverCurrent: monitor.isOver({ shallow: true }),
  })
)(EditLayout);

export default connect("layoutState", "readOnly")(LayoutContainer);



// WEBPACK FOOTER //
// ./src/editor/layout/components/Layout/DnDDealGroupView.js